<app-navbar></app-navbar>

<!-- <div class="bg-image" style="height: 100px" *ngIf="!loadingData">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-content">
          <h2>Notice</h2>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="container"
  *ngIf="!loadingData">
  <div class="row">
    <div class="col-md-4">
      <article class="item">
        <div class="ticker-wrapper-v-image">
          <ul class="news-ticker-v-image">
            <li *ngFor="let notice of Notices"
              (click)="showNotice($event, notice)"
              style="border: 1px solid #eeeeee; padding: 10px">
              <div class="thumbnail">
                <div style="border: 1px solid #eeeeee; width: 80px">
                  <div style="background-color: #082c5c"
                    class="text-center">
                    <span style="text-align: center; color: #ffffff">{{notice.CreatedDate | date:'dd'}}</span>
                  </div>
                  <div style="background-color: #f2f2f2"
                    class="text-center">
                    <span style="text-align: center; color: #caa545">{{notice.CreatedDate | date:'MMM'}}</span>
                  </div>
                </div>
              </div>
              <div>
                <div style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">
                  {{ notice.EnglishTitle }}
                </div>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
        </div>
      </article>
    </div>

    <div class="col-md-8">

      <div *ngIf="selectedNotice; else noNotice">
        <div class="notice-title">{{ selectedNotice.EnglishTitle }}</div>
        <div class="notice-details">
          <div class="notice-content">
          
            <img *ngIf="isImage(selectedNotice.FileLink)"
              [src]="'assets/img/school/notice/' + selectedNotice.FileLink"
              alt="Notice" />
            <div *ngIf="!isImage(selectedNotice.FileLink)">

              <iframe class="viewport"
                width="100%"
                frameBorder="0"
                [src]="urlSafe"></iframe>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noNotice>
        <div class="notice-title">Please select a notice to view</div>
      </ng-template>

    </div>
  </div>
</div> -->
<div class="bg-image" style="font-family: 'SolaimanLipi_bold', 'Ubuntu' !important; font-size: 87%;">
  <div class="container py-4">
    <div class="row align-items-start">

      <!-- Left Column: Notice Area -->
      <div class="col-md-8">

        <!-- Notice Header with Dropdown -->
        <div class="notice_header d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3 px-3 py-2">
          <h4 class="mb-0 flex-grow-1 text-nowrap">Bazlul Huq Khan School & College - NOTICE</h4>
          <div class="dropdown">
            <button 
              type="button"
              class="btn btn-secondary dropdown-toggle notice-dropdown px-3 py-1"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ selectedCategory }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <button class="dropdown-item" type="button" (click)="onSelectCategory('All Notices')">
                  All Notices
                </button>
              </li>
              <ng-container *ngFor="let item of notice_cat_values">
                <li>
                  <button class="dropdown-item" type="button" (click)="onSelectCategory(item)">
                    {{ item }}
                  </button>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>

        <!-- Notice List -->
        <ng-container *ngFor="let data of filteredNotices; let i = index">
          <div class="row pdf-holder align-items-center gx-0 mx-0 mb-3 border rounded shadow-sm py-2 px-1 bg-white">
            <div class="col-md-2 col-sm-3 text-center border-end">
              <i class="fa fa-lg fa-file mb-1"></i><br />
              <span><small>{{ data.CreatedDate | date }}</small></span>
            </div>
            <div class="col-md-7 col-sm-6 border-end px-2">
              <a class="notice-link fw-semibold text-decoration-none" [href]="data.FileLink" target="_blank">
                {{ data.EnglishTitle }}
              </a>
              <br />
              <span class="text-muted small">
                Total Views: {{ data.TotalHitCount }} |
                Notice Department: {{ data.NoticeCategoryName }}
              </span>
            </div>
            <div class="col-md-3 col-sm-3 text-center">
              <a [href]="data.FileLink" class="cloud-downloader text-decoration-none">
                <i class="fa fa-cloud-download mb-1"></i><br />
                <small>Download</small>
              </a>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Right Column: Aside -->
      <div class="col-md-4 mt-4 mt-md-0">
        <app-aside></app-aside>
      </div>
    </div>
  </div>
</div>

